import i18n from 'live/services/i18n'

import './admin'
import ptBr from './i18n/pt_br'
import enUs from './i18n/en_us'
import './widgets'

const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'en_us'
const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])
